// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"f705dc67","276":"069d22ce","482":"e057d792","551":"1f88aab5","640":"0198cb28","821":"f32b7352","828":"7bac459a","907":"4758ff24"}[chunkId] + ".chunk.js";
};